export const basePages = {
  home: 'Home',
  login: 'Login',
  logout: 'Logout',
  forbidden: 'Access Denied',
  notFound: 'Page Not Found',
} as const
